module.exports = __webpack_public_path__ + "static/media/logo_viacrediav.8f0c1c6f.svg";